module.exports = __webpack_public_path__ + "img/8_24.03e5dcf7.png";